(function () {
  'use strict';

  const COLORS = ['#e7c98a', '#f7e3a4', '#d4a85a', '#fff7d6', '#ffe9a8', '#c9962a'];
  const COUNT = 700;
  const BATCH = 120;

  function spawn(card, w, h) {
    const p = document.createElement('span');
    p.className = 'vsh-paypath-sparkle';

    const startX = Math.random() * w;
    const startY = Math.random() * h;

    // Puff outward (radial, slight upward bias)
    const angle = Math.random() * Math.PI * 2;
    const distance = 70 + Math.random() * 240;
    const puffX = Math.cos(angle) * distance;
    const puffY = Math.sin(angle) * distance - 30;

    // Then slow drop with a touch of horizontal drift
    const drift = (Math.random() - 0.5) * 70;
    const drop = 90 + Math.random() * 160;
    const finalX = puffX + drift;
    const finalY = puffY + drop;

    const size = 1.4 + Math.random() * 2.4;
    const duration = 2400 + Math.random() * 1800;
    const color = COLORS[Math.floor(Math.random() * COLORS.length)];
    const rotMid = (Math.random() - 0.5) * 220;
    const rotEnd = rotMid + (Math.random() - 0.5) * 360;

    p.style.left = startX + 'px';
    p.style.top = startY + 'px';
    p.style.width = size + 'px';
    p.style.height = size + 'px';
    p.style.background = color;
    p.style.boxShadow = '0 0 ' + (size * 2.4) + 'px ' + color;
    card.appendChild(p);

    const anim = p.animate(
      [
        { transform: 'translate(0,0) scale(1) rotate(0deg)', opacity: 1, offset: 0 },
        {
          transform:
            'translate(' + puffX + 'px,' + puffY + 'px) scale(0.85) rotate(' + rotMid + 'deg)',
          opacity: 1,
          offset: 0.22
        },
        {
          transform:
            'translate(' + finalX + 'px,' + finalY + 'px) scale(0.35) rotate(' + rotEnd + 'deg)',
          opacity: 0,
          offset: 1
        }
      ],
      { duration: duration, easing: 'cubic-bezier(.16,.84,.36,1)', fill: 'forwards' }
    );
    anim.onfinish = function () { p.remove(); };
  }

  function burst(card) {
    const w = card.offsetWidth;
    const h = card.offsetHeight;
    let i = 0;
    function tick() {
      const end = Math.min(i + BATCH, COUNT);
      for (; i < end; i++) spawn(card, w, h);
      if (i < COUNT) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  function init() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    document.querySelectorAll('.vsh-product-paypaths').forEach(function (container) {
      let fired = false;
      container.addEventListener(
        'click',
        function (e) {
          if (fired) return;
          const card = e.target.closest('.vsh-product-paypath');
          if (!card || !container.contains(card)) return;
          fired = true;
          burst(card);
        },
        { capture: true }
      );
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
